var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "global-filter-selected filter-selected" }, [
    _c(
      "div",
      {
        staticClass: "remove-filter remove-filter--secondary",
        on: {
          click: function ($event) {
            return _vm.$emit("click")
          },
        },
      },
      [
        _c("span", [_vm._t("default")], 2),
        _vm._v(" "),
        _c("span", { staticClass: "icon-remove" }),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }